import axios from "axios";


export const getBanner = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/banner/getBanner/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};

export const editBanner = (data) => {
  return axios
    .post(import.meta.env.VITE_ACTIVATE_BACKEND_API + "/api/banner/editbanner", data)
    .then((res) => res.data);
};
